// extracted by mini-css-extract-plugin
export default {"logo":"MobileMenuSlideout_logo__fgzrm"};